import api from './axios';

const athleteEventAPI = {
  // Get all athlete events with filters
  getAllAthleteEvents: async (filters) => {
    const response = await api.get('/athlete-events', { params: filters });
    return response.data; // Returns { success, data, pagination }
  },

  // Get single athlete event
  getAthleteEventById: async (eventId) => {
    const response = await api.get(`/athlete-events/${eventId}`);
    return response.data; // Returns { success, data }
  },

  // Create new athlete event
  createAthleteEvent: async (formData) => {
    const response = await api.post('/athlete-events', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Update athlete event
  updateAthleteEvent: async (eventId, formData) => {
    const response = await api.put(`/athlete-events/${eventId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Delete athlete event
  deleteAthleteEvent: async (eventId) => {
    const response = await api.delete(`/athlete-events/${eventId}`);
    return response.data;
  },

  // Get event statistics
  getEventStatistics: async () => {
    const response = await api.get('/athlete-events/statistics');
    return response.data;
  },

  // Get approved state associations
  getApprovedStateAssociations: async () => {
      const params = {verificationStatus: 'approved', limit: 1000};
  const response = await api.get('/admin/state-associations', { params });
  return response.data;
  },
};

export default athleteEventAPI;